// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4321c50f] .tox-tinymce {\n  width: 100% !important;\n  position: relative;\n  z-index: 10000;\n}\n[data-v-4321c50f] .el-dialog__body {\n  height: 800px;\n}\n", ""]);
// Exports
module.exports = exports;
